import React, { Component, useEffect, useState } from 'react';
import ServiceRequestsView from './ServiceRequestsView';
import crmservices from '../../wsclient/';
import { getCurrency } from '../../utils/common';
import NewServiceRequestView from './NewServiceRequestView';
import ModalAlert from '../../components/ModalAlert';
import t from '../../utils/translateUtil';
import Modal from '../../components/Modal';

function NewServiceRequestController(props) {
    const [showLoading, onShowLoading] = useState(false);
    const [request_info, setRequestInfo] = useState({});
    const [queues, setQueues] = useState([]);
    const [error, setError] = useState({})
    const [showUploadFile, onShowUploadFile] = useState(false);
    const [files, setFiles] = useState([]);
    const [filesUpload, setFilesUpload] = useState([]);

    useEffect(() => {
        getQueues();
    }, [])
    const getQueues = async () => {
        onShowLoading(true);
        let result = await crmservices.config.getQueues();
        if (result.code === 'OK' && result.data && result.data.content) {
            let queues = [...result.data.content]
            queues.forEach(element => {
                element.label = element.name
                element.value = element.id
            });
            setQueues(queues);
        }

        onShowLoading(false);
    }

    const onCreate = async (values) => {
        if (!request_info.queue_id) {
            showAlert(true, t('please_chosse_classification'));
            return;
        }
        let new_request_info = { ...request_info };
        new_request_info.description = values.description;

        setRequestInfo(prevState => ({
            ...prevState,
            description: values.description
        }))
        onShowLoading(true);
        try {
            let fileUploaded = await onUploadFile();
            let result = await crmservices.config.createServiceRequest(new_request_info);
            if (result.code === 'OK') {
                if (fileUploaded.length > 0) {
                    await onAddSRAttachment(result.data.id, fileUploaded);
                }
                showAlert(true, t('create_service_request_success'), props.onCloseAndRefresh);
            }
            else {
                showAlert(true, t('create_service_request_failed'));
            }
        }
        catch (e) {
            showAlert(true, t('EXCEPTION_PROCESS'))
        }

        onShowLoading(false);
    }

    const onUploadFile = async () => {
        let _filesUploaded = [];
        try {
            console.log("files:", files)
            if (files.length > 0) {
                for (let i = 0; i < files.length; i++) {
                    const result = await crmservices.config.uploadFilesNew({file: files[i]});
                    if (result.code == 'OK' && result.data.id) {
                        _filesUploaded.push(result.data.id);
                    }
                }
            }
        } catch (error) {
            console.log("onUploadFile exception:", error);
        }
        return _filesUploaded
    }

    const onAddSRAttachment = async (service_request_id, filesUploaded) => {
        try {
            for (let i = 0; i < filesUploaded.length; i++) {
                await crmservices.config.uploadAttachmentSR({
                    service_id: service_request_id,
                    file_id: filesUploaded[i]
                });
            }
        } catch (error) {
            console.log("onAddSRAttachment exception:", error);
        }
    }

    const onSelectQueue = (value) => {
        //console.log('onSelectQueue value===', value)
        setRequestInfo(prevState => ({
            ...prevState,
            queue_id: value.value
        }))
    }
    const showAlert = (status, message, callback) => {
        onShowLoading(false);
        setError({
            showAlert: true,
            message: message,
            status: status,
            callback: callback
        })
    }

    const onCloseAlert = () => {
        onShowLoading(false);
        if (error.callback) {
            error.callback();
        }
        setError({
            showAlert: false,
            message: '',
            status: '',
            callback: null
        })
    }

    const onCompleteFileUpload = (files) => {
        console.log("files===", files);
        console.log("filesUpload==", filesUpload);
        if(filesUpload && filesUpload.length < 3){
            setFilesUpload(files);
        } else if(filesUpload && filesUpload.length >= 3){
            showAlert(true, t('error_max_files'));
        }
    }

    const onSaveStateFiles = () => {
        console.log("filesUpload==", filesUpload);
        if(filesUpload && filesUpload.length > 0) setFiles(filesUpload);
        onShowUploadFile(false);
    }

    const onDeleteFile = (file) => {
        console.log("file==", file);
        const filesExist = files.filter(f=>f.id !== file.id);
        setFiles(filesExist);
    }

    // console.log("files==", files);
    return (
        <div>
            <NewServiceRequestView
                open={props.open}
                onClose={props.onClose}
                request_info={request_info}
                showLoading={showLoading}
                queues={queues}
                showUploadFile={showUploadFile}
                files={files}
                onCreate={onCreate}
                onSelectQueue={onSelectQueue}
                onShowUploadFile={onShowUploadFile}
                onCompleteFileUpload={onCompleteFileUpload}
                onSaveStateFiles={onSaveStateFiles}
                onDeleteFile={onDeleteFile}
            />
            {error.showAlert && <ModalAlert
                open={error.showAlert}
                onClose={onCloseAlert}
                hideHeader={true}
                message={error.message}
                error={error.status}
                title={error.title}
            />}
        </div>
    );
}

export default NewServiceRequestController;